import script from "./ZPreloader.vue?vue&type=script&setup=true&lang=js"
export * from "./ZPreloader.vue?vue&type=script&setup=true&lang=js"

import "./ZPreloader.vue?vue&type=style&index=0&id=34cda50e&lang=scss"

const __exports__ = script;

export default __exports__